import React, { useState } from 'react'
import { useInView } from 'react-intersection-observer'
import ProjectCard from './ProjectCard'
import SectionBackground from './SectionBackground'
import { featuredProjects, otherProjects } from '../data/projects'

const Projects = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  })

  const [showAll, setShowAll] = useState(false)

  return (
    <section
      id="projects"
      ref={ref}
      className="relative py-20 px-4 sm:px-6 lg:px-8"
    >
      <SectionBackground variant="projects" />
      <div className="max-w-7xl mx-auto relative z-10">
        {/* Section Header */}
        <div
          className={`text-center mb-16 transition-all duration-1000 ${
            inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-navy-dark dark:text-navy-lightest mb-4">
            Featured Projects
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-navy-medium to-navy-deep dark:from-github-border dark:to-github-border mx-auto mb-4"></div>
          <p className="text-xl text-navy-base dark:text-navy-soft max-w-2xl mx-auto">
            A selection of projects that showcase my skills and experience
          </p>
        </div>

        {/* Featured Projects */}
        <div className="space-y-20 mb-20">
          {featuredProjects.map((project, idx) => (
            <ProjectCard
              key={project.id}
              project={project}
              featured
              reverse={idx % 2 !== 0}
              delay={idx * 200}
            />
          ))}
        </div>

        {/* Other Projects Grid */}
        <div>
          <h3 className="text-2xl sm:text-3xl font-bold text-navy-dark dark:text-navy-lightest mb-8 text-center">
            Other Noteworthy Projects
          </h3>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
            {otherProjects
              .slice(0, showAll ? otherProjects.length : 6)
              .map((project, idx) => (
                <ProjectCard
                  key={project.id}
                  project={project}
                  delay={idx * 100}
                />
              ))}
          </div>

          {otherProjects.length > 6 && (
            <div className="text-center">
              <button
                onClick={() => setShowAll(!showAll)}
                className="px-8 py-3 bg-white dark:bg-github-border-muted text-navy-dark dark:text-github-text border-2 border-navy-soft dark:border-github-border rounded-lg font-semibold hover:border-accent hover:text-accent dark:hover:bg-github-border transition-all duration-300"
              >
                {showAll ? 'Show Less' : 'Show More'}
              </button>
            </div>
          )}
        </div>
      </div>
    </section>
  )
}

export default Projects